import client from 'lib/api/client';

export const getErrorDashboard = () => client.get('/error/status');

export const getErrorList = ({
  page,
  orderBy,
  orderDir,
  isDone,
  filterName,
  filterTitle,
  searchKeyword,
}) =>
  client.get('/error', {
    params: {
      page,
      limit: 10,
      orderBy,
      orderDir,
      isDone,
      filterName,
      filterTitle,
      searchKeyword,
    },
  });

export const updateMemo = ({ id, memo, doneAt }) =>
  client.post(
    `/error/${id}/memo`,
    {
      memo,
      doneAt,
    },
    {
      headers: {
        'X-Method-Override': 'PATCH',
      },
    },
  );

export const getMemo = id => client.get(`/error/${id}/memo`);
